import type { FC } from 'react';
import type { KeyName } from './keys';
import { KEYS } from './keys';
import styles from './Kbd.module.css';

export interface KbdProps {
  children: KeyName | (string & Record<never, never>);
}

export const Kbd: FC<KbdProps> = ({ children }) => {
  const key = KEYS[children as KeyName] as (typeof KEYS)[KeyName] | undefined;

  return (
    <kbd
      className={styles.kbd}
      data-width={key?.width ?? 'square'}
      aria-label={key?.label}
    >
      {key?.legend ?? children}
    </kbd>
  );
};
